module.exports = __webpack_public_path__ + "img/Carte-Virtuelle-APAYM-UBA.a69d5c1e.png";